<script>
  import { letters, topics, userLoggedIn } from "../services/store";
  import { replace } from "svelte-spa-router";
  import { location } from "svelte-spa-router";
  import { beforeUpdate } from "svelte";
  import { _ } from "svelte-i18n";

  let selected;
  let buttons;
  let target;
  let translate;
  const validTargets = ["letters", "nature", "culture", "world"];

  beforeUpdate(() => {
    validTargets.forEach((s) => {
      if ($location.indexOf(`/${s}/`) > -1) {
        target = s;
        if (s === "letters") {
          translate = false;
          buttons = $letters;
          selected = $location.split(`/${s}/`)[1];
        } else if ($topics && $topics[s]) {
          translate = true;
          let split = $location.split(`/`);
          if (split && split.length > 2) {
            selected = $location.split(`/`)[2];
          }
          buttons = $topics[s].map((s) => {
            return { value: s, display: s };
          });
        } else {
          buttons = null;
        }
      }
    });
  });
  function handleKeyDown(params) {
    if ($userLoggedIn && $letters && target === "letters") {
      let key = params.key;
      let foundLetter = $letters.find((l) => l.display === key);
      if (foundLetter) {
        navToLetter(foundLetter);
      }
    }
  }
  function navToLetter(letter) {
    replace("/" + target + "/" + letter.value);
  }
</script>

<svelte:window on:keypress={handleKeyDown} />
<section
  class="bg-gradient-to-r 
{target == 'letters'
    ? ''
    : `from-gradient_${target}1 to-gradient_${target}2`}
"
>
  {#if buttons}
    <div class="flex flex-wrap glass justify-center py-1">
      {#each buttons as button (button.value)}
        <button
          class:selected={selected === button.value}
          class="leading-4 customShadow 
            {target == 'letters'
            ? 'w-9 h-9 m-0.5'
            : 'w-50 h-9 m-1 px-20'}
            {button.value === 'scharfes_s'
            ? ''
            : 'uppercase'}
       transition duration-500 ease-in-out 
      text-gray-600  border rounded-full transform 
       hover:bg-accent-100 hover:-translate-y-1 hover:scale-110
       focus:bg-accent-100 focus:-translate-y-1 focus:scale-110
       "
          on:click={navToLetter(button)}
        >
          {#if translate}
            {$_(`topics.letterNav.${button.display}`)}
          {:else}{button.display}{/if}
        </button>
      {/each}
    </div>
  {/if}
</section>

<style>
  .selected {
    background-color: #d97706;
    border: 1px solid white;
    color: white;
  }
</style>
